class PencilBar extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.closeBtn = this.querySelector("[data-close]");
    this.messages = Array.from(this.querySelectorAll("[data-pencil-message]"));
    this.signupMessage = this.querySelector("[data-signup-message]");
    this.currentIndex = Math.max(
      this.messages.findIndex((message) =>
        message.classList.contains("is-active"),
      ),
      0,
    );
    this.rotationTimer = null;
    this.transitionTimer = null;
    this.rotationInterval = 6000;
    this.pointerInside = false;
    this.focusInside = false;
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.handleClose = () => this.close();
    this.handleSignupClick = (event) => this.openSignupMessage(event);
    this.handlePointerEnter = () => {
      this.pointerInside = true;
      this.pauseRotation();
    };
    this.handlePointerLeave = () => {
      this.pointerInside = false;
      this.resumeRotation();
    };
    this.handleFocusIn = () => {
      this.focusInside = true;
      this.pauseRotation();
    };
    this.handleFocusOut = (event) => {
      this.focusInside = this.contains(event.relatedTarget);
      if (!this.focusInside) this.resumeRotation();
    };

    this.closeBtn?.addEventListener("click", this.handleClose);
    this.signupMessage?.addEventListener("click", this.handleSignupClick);
    this.addEventListener("mouseenter", this.handlePointerEnter);
    this.addEventListener("mouseleave", this.handlePointerLeave);
    this.addEventListener("focusin", this.handleFocusIn);
    this.addEventListener("focusout", this.handleFocusOut);
    this.resumeRotation();
  }

  disconnectedCallback() {
    this.pauseRotation();
    if (this.transitionTimer) window.clearTimeout(this.transitionTimer);
    this.closeBtn?.removeEventListener("click", this.handleClose);
    this.signupMessage?.removeEventListener("click", this.handleSignupClick);
    this.removeEventListener("mouseenter", this.handlePointerEnter);
    this.removeEventListener("mouseleave", this.handlePointerLeave);
    this.removeEventListener("focusin", this.handleFocusIn);
    this.removeEventListener("focusout", this.handleFocusOut);
    this.initialized = false;
  }

  close() {
    this.pauseRotation();
    this.style.display = "none";
    document.dispatchEvent(new CustomEvent("pencilbar:hide"));
  }

  openSignupMessage(event) {
    event.preventDefault();
    const formId = this.dataset.klaviyoFormId;

    if (formId) {
      try {
        if (window._klOnsite && typeof window._klOnsite.push == "function") {
          window._klOnsite.push(["openForm", formId]);
          return;
        }
      } catch {}
    }

    this.focusNewsletter();
  }

  focusNewsletter() {
    const target = document.querySelector(
      this.dataset.newsletterTarget || ".footer__newsletter",
    );
    const input = target?.querySelector(
      'input[name="email"], input[type="email"]',
    );

    target?.scrollIntoView({
      behavior: this.reducedMotion.matches ? "auto" : "smooth",
      block: "center",
    });

    if (input) {
      window.setTimeout(() => input.focus({ preventScroll: true }), 250);
    }
  }

  isHolding() {
    return this.pointerInside || this.focusInside;
  }

  resumeRotation() {
    if (this.rotationTimer || this.messages.length < 2 || this.isHolding())
      return;
    this.rotationTimer = window.setInterval(
      () => this.showNextMessage(),
      this.rotationInterval,
    );
  }

  pauseRotation() {
    if (!this.rotationTimer) return;
    window.clearInterval(this.rotationTimer);
    this.rotationTimer = null;
  }

  showNextMessage() {
    const current = this.messages[this.currentIndex];
    this.currentIndex = (this.currentIndex + 1) % this.messages.length;
    const next = this.messages[this.currentIndex];

    current.classList.remove("is-active");
    current.classList.add("is-exiting");
    current.setAttribute("aria-hidden", "true");
    current.setAttribute("tabindex", "-1");
    next.classList.add("is-active");
    next.setAttribute("aria-hidden", "false");
    next.removeAttribute("tabindex");

    if (this.transitionTimer) window.clearTimeout(this.transitionTimer);
    this.transitionTimer = window.setTimeout(() => {
      current.classList.remove("is-exiting");
      this.transitionTimer = null;
    }, 800);
  }
}

if (!customElements.get("pencil-bar")) {
  customElements.define("pencil-bar", PencilBar);
}
